export const CREATE_COPY = 'CREATE_COPY'
export const RECEIVE_COPY = 'RECEIVE_COPY'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const RESET_REQUEST = 'RESET_REQUEST'
